import {
  publishItem as publicPublishItem,
  publishItemById as publicPublishItemById,
  createDraftItem as publicCreateDraftItem,
  publishMultiStoryDraft as publicPublishMultiStoryDraft,
  getItem as publicGetItem,
  getItems as publicGetItems,
  queryItems as publicQueryItems,
  cancelScheduledItem as publicCancelScheduledItem,
  updateItem as publicUpdateItem,
  rescheduleItem as publicRescheduleItem,
  deleteItem as publicDeleteItem,
  bulkPublishItems as publicBulkPublishItems,
} from './promote-publisher-v1-item-items.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onItemPublishFailed as publicOnItemPublishFailed } from './promote-publisher-v1-item-items.public.js';
import { onItemPublishScheduled as publicOnItemPublishScheduled } from './promote-publisher-v1-item-items.public.js';
import { onItemPublishStarted as publicOnItemPublishStarted } from './promote-publisher-v1-item-items.public.js';
import { onItemPublished as publicOnItemPublished } from './promote-publisher-v1-item-items.public.js';

export const publishItem: MaybeContext<
  BuildRESTFunction<typeof publicPublishItem> & typeof publicPublishItem
> = /*#__PURE__*/ createRESTModule(publicPublishItem);
export const publishItemById: MaybeContext<
  BuildRESTFunction<typeof publicPublishItemById> & typeof publicPublishItemById
> = /*#__PURE__*/ createRESTModule(publicPublishItemById);
export const createDraftItem: MaybeContext<
  BuildRESTFunction<typeof publicCreateDraftItem> & typeof publicCreateDraftItem
> = /*#__PURE__*/ createRESTModule(publicCreateDraftItem);
export const publishMultiStoryDraft: MaybeContext<
  BuildRESTFunction<typeof publicPublishMultiStoryDraft> &
    typeof publicPublishMultiStoryDraft
> = /*#__PURE__*/ createRESTModule(publicPublishMultiStoryDraft);
export const getItem: MaybeContext<
  BuildRESTFunction<typeof publicGetItem> & typeof publicGetItem
> = /*#__PURE__*/ createRESTModule(publicGetItem);
export const getItems: MaybeContext<
  BuildRESTFunction<typeof publicGetItems> & typeof publicGetItems
> = /*#__PURE__*/ createRESTModule(publicGetItems);
export const queryItems: MaybeContext<
  BuildRESTFunction<typeof publicQueryItems> & typeof publicQueryItems
> = /*#__PURE__*/ createRESTModule(publicQueryItems);
export const cancelScheduledItem: MaybeContext<
  BuildRESTFunction<typeof publicCancelScheduledItem> &
    typeof publicCancelScheduledItem
> = /*#__PURE__*/ createRESTModule(publicCancelScheduledItem);
export const updateItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateItem> & typeof publicUpdateItem
> = /*#__PURE__*/ createRESTModule(publicUpdateItem);
export const rescheduleItem: MaybeContext<
  BuildRESTFunction<typeof publicRescheduleItem> & typeof publicRescheduleItem
> = /*#__PURE__*/ createRESTModule(publicRescheduleItem);
export const deleteItem: MaybeContext<
  BuildRESTFunction<typeof publicDeleteItem> & typeof publicDeleteItem
> = /*#__PURE__*/ createRESTModule(publicDeleteItem);
export const bulkPublishItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkPublishItems> &
    typeof publicBulkPublishItems
> = /*#__PURE__*/ createRESTModule(publicBulkPublishItems);
/** */
export const onItemPublishFailed: BuildEventDefinition<
  typeof publicOnItemPublishFailed
> &
  typeof publicOnItemPublishFailed = /*#__PURE__*/ createEventModule(
  publicOnItemPublishFailed
);
/** */
export const onItemPublishScheduled: BuildEventDefinition<
  typeof publicOnItemPublishScheduled
> &
  typeof publicOnItemPublishScheduled = /*#__PURE__*/ createEventModule(
  publicOnItemPublishScheduled
);
/** */
export const onItemPublishStarted: BuildEventDefinition<
  typeof publicOnItemPublishStarted
> &
  typeof publicOnItemPublishStarted = /*#__PURE__*/ createEventModule(
  publicOnItemPublishStarted
);
/** */
export const onItemPublished: BuildEventDefinition<
  typeof publicOnItemPublished
> &
  typeof publicOnItemPublished = /*#__PURE__*/ createEventModule(
  publicOnItemPublished
);

export {
  ChannelName,
  ConsumerType,
  Type,
  ItemType,
  Status,
  MediaType,
  GbpPostCallToActionType,
  TikTokPrivacyLevel,
  SchedulingRestrictedReason,
  SortOrder,
  BulkPublishItemsPolicy,
  WebhookIdentityType,
} from './promote-publisher-v1-item-items.universal.js';
export {
  Item,
  ItemDataOneOf,
  PublishingTarget,
  ItemAutomation,
  ItemAutomationTriggerOneOf,
  ItemAutomationActionOneOf,
  CommentTrigger,
  SendPrivateReplyAction,
  Channel,
  SchedulingInfo,
  ConsumerInfo,
  InstagramPost,
  InstagramPostUrlOneOf,
  MediaWrapper,
  Media,
  InstagramInsights,
  InstagramStory,
  InstagramStoryInsights,
  FacebookPost,
  FacebookPostUrlOneOf,
  LinkMetadata,
  FacebookInsights,
  FacebookImpressions,
  FacebookInteractions,
  FacebookReactions,
  FacebokActivity,
  FacebookReel,
  FacebookStory,
  YouTubeVideo,
  YoutubeInsights,
  YouTubeShort,
  LinkedinPost,
  LinkedinPostUrlOneOf,
  LinkedinPostInsights,
  TwitterPost,
  TwitterPostUrlOneOf,
  TwitterInsights,
  PinterestPost,
  PinterestInsights,
  GbpPost,
  GbpPostCallToAction,
  GbpInsights,
  TikTokVideo,
  TikTokInsights,
  TikTokPhoto,
  SiteAnalytics,
  ConversionFunnel,
  InsightsSummary,
  DraftInfo,
  PublicationErrorDetails,
  AssetReference,
  ItemAutomationsWrapper,
  PublishItemRequest,
  ItemExtras,
  PublishItemResponse,
  ItemPublishStarted,
  ItemPublished,
  ItemPublishFailed,
  ItemPublishScheduled,
  PublishItemByIdRequest,
  PublishItemByIdResponse,
  CreateDraftItemRequest,
  CreateDraftItemResponse,
  GetOrCreateWixelBindingByFileRequest,
  GetOrCreateWixelBindingByFileResponse,
  PublishDraftRequest,
  PublishDraftResponse,
  PublishMultiStoryDraftRequest,
  PublishMultiStoryDraftResponse,
  BulkItemsResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  IsEligibleForSchedulingRequest,
  IsEligibleForSchedulingResponse,
  GetItemRequest,
  GetItemResponse,
  GetItemsRequest,
  GetItemsResponse,
  QueryItemsRequest,
  Query,
  Sorting,
  AddressLocation,
  Paging,
  QueryItemsResponse,
  PagingMetadata,
  CancelScheduledItemRequest,
  CancelScheduledItemResponse,
  UpdateItemRequest,
  UpdateItemResponse,
  RescheduleItemRequest,
  RescheduleItemResponse,
  DeleteItemRequest,
  DeleteItemResponse,
  BulkPublishItemsRequest,
  BulkPublishItemsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ItemPublishFailedEnvelope,
  ItemPublishScheduledEnvelope,
  ItemPublishStartedEnvelope,
  ItemPublishedEnvelope,
  PublishItemOptions,
  PublishItemByIdOptions,
  CreateDraftItemOptions,
  PublishMultiStoryDraftOptions,
  UpdateItem,
  RescheduleItemOptions,
  BulkPublishItemsOptions,
} from './promote-publisher-v1-item-items.universal.js';
export {
  ChannelNameWithLiterals,
  ConsumerTypeWithLiterals,
  TypeWithLiterals,
  ItemTypeWithLiterals,
  StatusWithLiterals,
  MediaTypeWithLiterals,
  GbpPostCallToActionTypeWithLiterals,
  TikTokPrivacyLevelWithLiterals,
  SchedulingRestrictedReasonWithLiterals,
  SortOrderWithLiterals,
  BulkPublishItemsPolicyWithLiterals,
  WebhookIdentityTypeWithLiterals,
  PublishItemApplicationErrors,
  PublishItemByIdApplicationErrors,
  PublishMultiStoryDraftApplicationErrors,
  CancelScheduledItemApplicationErrors,
  UpdateItemApplicationErrors,
  RescheduleItemApplicationErrors,
  DeleteItemApplicationErrors,
  BulkPublishItemsApplicationErrors,
} from './promote-publisher-v1-item-items.universal.js';
